module.exports = __webpack_public_path__ + "static/guard02-1cef626c25ac3ad4ff299b7ed532b9b3.jpg";